import React from "react";

const SchemaDialysisCare = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
            {
                "@type": "Question",
                name: "How often is dialysis required?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Most patients need dialysis two to three times per week, depending on their kidney function and overall health condition. The nephrologist determines the frequency based on medical evaluation."
                }
            },
            {
                "@type": "Question",
                name: "Is dialysis painful?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Dialysis is generally not painful. Some patients may experience mild discomfort during needle insertion, but the procedure itself is usually well tolerated."
                }
            },
            {
                "@type": "Question",
                name: "How long does each dialysis session last?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "A typical hemodialysis session lasts 3 to 4 hours. The duration may vary depending on the patient’s medical condition."
                }
            },
            {
                "@type": "Question",
                name: "Can dialysis patients live a normal life?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes. With proper treatment, medication, dietary management, and regular follow-ups, many dialysis patients lead active and productive lives."
                }
            },
            {
                "@type": "Question",
                name: "Is emergency dialysis available in Patna?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes. HDNA Aarogyam Hospital provides emergency dialysis services for patients requiring urgent renal support."
                }
            },
            {
                "@type": "Question",
                name: "What are the different types of dialysis available?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "There are two main types: Hemodialysis – blood is filtered using a dialysis machine. Peritoneal dialysis – the abdominal lining acts as a natural filter. Our nephrologists recommend the most suitable option after evaluation."
                }
            },
            {
                "@type": "Question",
                name: "Who needs dialysis treatment?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Dialysis is required for patients with chronic kidney disease (CKD), end-stage renal disease (ESRD), acute kidney injury, severe electrolyte imbalance, and fluid overload conditions."
                }
            },
            {
                "@type": "Question",
                name: "What precautions should dialysis patients follow?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Patients should follow a kidney-friendly diet, limit fluid intake as advised, take prescribed medications regularly, attend all scheduled dialysis sessions, and monitor blood pressure and blood sugar levels."
                }
            },
            {
                "@type": "Question",
                name: "How is dialysis access created for treatment?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "For hemodialysis, a vascular access (usually an AV fistula, graft, or catheter) is created to allow safe and efficient blood flow during treatment."
                }
            },
            {
                "@type": "Question",
                name: "Why choose HDNA Aarogyam Hospital for dialysis care in Patna?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Patients choose HDNA Aarogyam Hospital because of experienced nephrology specialists, advanced dialysis machines, strict infection control protocols, personalized patient care, and emergency support availability."
                }
            }
        ]
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
    );
};

export default SchemaDialysisCare;